export const environment = {
  production: true,
  API_URL: 'assets/config/app.config.json'
};